import { render } from "./FieldLabel.vue?vue&type=template&id=170327ad&scoped=true"
import script from "./FieldLabel.vue?vue&type=script&lang=ts"
export * from "./FieldLabel.vue?vue&type=script&lang=ts"

import "./FieldLabel.vue?vue&type=style&index=0&id=170327ad&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-170327ad"

export default script